module.exports = __webpack_public_path__ + "media/auth/img/sidebar-image-low-37ff260386dfb30b02f0f688a3b75360.jpg";